/**
 * Copyright (c) Qwoach LLC 2025. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 27.06.25
 *
 */
import BaseObject from "@shared/BaseObject.js";
import {Type} from "@qwoach/class-transformer-wrapper";
import LineItem from "@shared/Invoice/LineItem";

export default class LineItemGroup extends BaseObject {

	groupName: string = null;

	@Type(() => LineItem)
	lineItems: LineItem[] = [];


	constructor(options = {}) {
		super();

		this.groupName = options.groupName || null;
		this.lineItems = options.lineItems || [];
	}
}
